import { useEffect } from 'react';
import useUserStore from '../../Stores/UserStore';

/**
 * Syncs document lang and dir based on logged-in user's language.
 * Sets dir="rtl" for Arabic. Uses English when not logged in.
 */
export default function TranslateProvider({ children }) {
  const langCode = useUserStore((s) => s.appLanguage ?? 'en');

  useEffect(() => {
    document.documentElement.lang = langCode;
    document.documentElement.dir = langCode === 'ar' ? 'rtl' : 'ltr';
  }, [langCode]);

  return children;
}
